export default __webpack_public_path__ + "static/media/single-rope-border-right.9117be18.svg";